import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Toolbar from '../../components/common/Toolbar';
import ActivationServices from '../../components/blocks/ActivationServices';
import { updateAutoSync } from '../../store/actions/activation';

function ActivationServicesContainer(props) {
  return (
    <>
      <Toolbar name="Services" />
      <ActivationServices {...props} />
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateAutoSync: (data) => dispatch(updateAutoSync(data)),
});

export default connect(null, mapDispatchToProps)(ActivationServicesContainer);

ActivationServicesContainer.propTypes = {
  supplierData: PropTypes.object.isRequired,
  updateAutoSync: PropTypes.func.isRequired,
};
